import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { ContactsDialog } from "../../page/PersonRepositoryPage/ContactsDialog";
import { useGetA, usePostAgreementRescheduledPaymentList } from "../../services/agreementsService";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { CircularProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

export function PreviewContactForAgreementOverduePaymentButton({ personId, contactId, agreementOverduePaymentId, contactData, color = "primary" }) {
    const { openDialog: openContactsDialog } = useDialogBetter();
    const { mutate: getAgreementRescheduledPayments, isPending } = usePostAgreementRescheduledPaymentList();

    const prepareDataForPayment = (payment) => {
        return {
                id: payment.id,
                tranche_name: payment.tranche_name,
                agreement_payment_amount: payment.agreement_payment_amount,
                due_date: payment.agrepay_due_date,
                paid_amount: payment.paid_amount,
                remaining_amount: payment.remaining_amount,
                agreement_payment_parent_id: payment.agreement_payment_parent_id,
                agreement_payment_parent_name: payment.agreement_payment_parent_name,
                agreement_payment_parent_amount: payment.agreement_payment_parent_amount,
                is_paid: payment.is_paid,
        }
    }

    const handleOpenContactDialog = () => {
        getAgreementRescheduledPayments(
            {
                contact_id : contactId,
            },
            {
                onSuccess: (data, variables, context) => {
                    openContactsDialog({
                        Component: ContactsDialog,
                        componentProps: {
                            isPreview: true,
                            personId: personId,
                            agreementOverduePaymentId: agreementOverduePaymentId,
                            rowData: {
                                ...contactData,
                                rawPayments: data.map(payment=>prepareDataForPayment(payment))
                            },
                        },
                    });
                    
                },
            },
        );
    };

    return (
        isPending 
            ? <CircularProgress/>
            : <IconButton
                    color={color}
                    onClick={handleOpenContactDialog}
                >
                    <VisibilityIcon />
                </IconButton>
    );
}
